import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export type PlanInterval = "monthly" | "quarterly" | "annual" | "flash" | "flash_b";

/**
 * Hook that handles checkout for both authenticated and guest users.
 * Supports monthly and annual plans.
 */
export const useGuestCheckout = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const startCheckout = async (plan: PlanInterval = "annual") => {
    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke("create-checkout", {
        body: { plan },
      });
      if (error) throw error;
      if (data?.url) window.location.href = data.url;
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  };

  return { startCheckout, loading };
};
